import React, { useEffect, useState } from "react";
import { retranslate } from "../lib/googleTranslate";

// /results doesn't report progress, so these advance on a timer and stop on
// the last one instead of looping back to the start.
const MESSAGES = [
  "Reading your answers…",
  "Finding careers that match your interests…",
  "Grouping careers by skills…",
  "Explaining why each career fits you…",
  "Almost there…",
];
const STEP_MS = 3500;

const ResultsProgressMessage = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    // Every message is in the DOM from the start and only its opacity changes,
    // so Google Translate needs one pass here rather than one per message.
    retranslate();
    const timer = setInterval(() => {
      setStep((s) => Math.min(s + 1, MESSAGES.length - 1));
    }, STEP_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="mt-4 grid text-center text-sm text-text-secondary"
      role="status"
      aria-live="polite"
    >
      {MESSAGES.map((message, i) => (
        <p
          key={message}
          aria-hidden={i !== step}
          className={`col-start-1 row-start-1 transition-opacity duration-500 ${
            i === step ? "opacity-100" : "opacity-0"
          }`}
        >
          {message}
        </p>
      ))}
    </div>
  );
};

export default ResultsProgressMessage;
